module.exports = __webpack_public_path__ + "static/pong-ba1a40dc9ef241a290f54825721a3b8d.mp3";